// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"blog-post-header_headerContainer__11m9Z","headerTitle":"blog-post-header_headerTitle__J2yfF"};